<script>
	import { Link } from 'svelte-routing';
</script>

<main>
	<h2 style="text-align: center;">HM - Habilidades Médicas e Estações Clínicas</h2>
	<div id="semesters">
		<p></p>
		<details>
			<summary>1º semestre</summary>
			<p>-</p>
		</details>
		<p></p>
		<details>
			<summary>2º semestre</summary>
			<p>-</p>
		</details>
		<p></p>
		<details>
			<summary>3º semestre</summary>
			<br>
			<b>
				ORDEM: OFICINA + SIMULAÇÕES COM REFLEXÕES DO QUE PODERIA MELHORAR + REFERÊNCIAS USADAS PARA RESPONDER AS QUESTÕES DO ULTIMO FECHAMENTO + REFLEXÕES SOBRE AS 6 PERGUNTAS QUE JÁ FIZ DO PROXIMO FECHAMENTO + ESTAÇÕES 
			</b>
			<br>
			<b>OFICINA</b>
			<p>
				Acabei não indo para a oficina porque eu estou com inflamação em todo meu sistema digestório: retite, colite, duodenite, ileíte e gastrite. Fui fazer colonoscopia, e foi confirmado que minha dor que sinto vem do intestino irritável. Nas imagens está tudo em perfeito estado, mas quando é feito a biópsia deu reagente para as ites citadas anteriormente.
				<br>
				Manobra de Lemos-Torres: Percussão no epigástrio para avaliar dor irradiada à vesícula biliar (sugere colecistite).
				<br>
				Palpação do baço em posição de Schuster: Paciente em decúbito lateral direito; facilita a detecção de esplenomegalia.
				<br>
				Teste do piparote: Detecta ascite; identifica onda líquida abdominal ao percutir um lado e sentir no outro, com mão no centro.
				<br>
				Teste da macicez: Percussão abdominal para identificar áreas de macicez que se deslocam com a posição (ascite).
				<br>
				Sinal de Blumberg: Dor à descompressão brusca do abdome; indica irritação peritoneal.
				<br>
				Sinal de Murphy: Interrupção da inspiração à palpação do hipocôndrio direito; sugere colecistite aguda.
				<br>
				Sinal de Rovsing: Dor no quadrante inferior direito ao comprimir o esquerdo; indica apendicite.
				<br>
				Manobra do psoas: Dor ao estender a perna direita; sugere apendicite retrocecal.
				<br>
				Manobra do obturador: Dor ao rotacionar internamente a coxa flexionada; indica apendicite pélvica.
			</p>
			<br>
			<b>1 - SIMULAÇÃO</b>
			Habilidades Médicas e Estações Clínicas - Simulação com paciente ator
			<br>
			Identificação do paciente
			<br>
			Nome: Maria José Gaia
			<br>
			Idade: 72 anos
			<br>
			Sexo: Feminino
			<br>
			Data da consulta: 25/04/2025
			<br>
			<br>
			Paciente vem à consulta de início apenas para renovação de receita de MUC - Losartana 50mg 
			(Diagnóstico de hipertensão há 20 anos). Ao decorrer da anamnese, 
			refere episódios recorrentes de desconforto abdominal pós prandial, 
			há cerca de 3 meses, menciona sentir queimação, azia,estufamento, náuseas e 
			que “ a comida não cai bem”.
			<br>
			Alimentação inadequada, pobre em nutrientes. Paciente toma café em jejum acompanhado apenas de bolacha maizena de manhã/ a tarde, almoça frango ultraprocessado frito acompanhado de água com gás e janta pão com presunto.
			O sono da paciente é irregular, com despertares ao decorrer da noite. Maria José é avó de dois adolescentes e ultimamente tem cuidado deles o dia inteiro (filha trabalha e conta com a rede de apoio da mãe).
			<br>
			Objetivo (O)<br>
			Sinais vitais:<br>
			PA: 135 x 80 mmHg<br>
			FC: 80 bpm<br>
			FR: 18 irpm<br>
			Temperatura: Afebril<br>
			Exame físico geral:<br>
			Bom Estado Geral, Corada, Hidratada, Acianótica e Eupneica.<br>
			-Mucosas normocoradas<br>

			Couro cabeludo sem alterações<br>

			Linfonodos não palpáveis e indolores<br>
			-Tempo de enchimento capilar ≤ 2 segundos<br>
			Avaliação (A)<br>
			Síndrome gástrica crônica, provavelmente associada a hábitos alimentares inadequados, baixa ingestão hídrica complementada por sintomatologia ansiosa predominante.<br>
			Plano (P)<br>
			● Oriento mudança no estilo de vida<br>
			● Oriento atenção prioritária à saúde mental e manejo do estresse<br>
			● Oriento aumentar a ingestão de água<br>
			● Oriento não tomar café em jejum<br>
			Reflexão<br>
			Nem sempre o que a g gente estuda se traduz como a gente espera na prática.<br>
			Na simulação clínica, eu entrei confiante, pronto pra aplicar tudo que havia revisado.<br>
			Mas ali, diante da paciente, me dei conta de que a técnica sozinha não sustenta tudo.<br>
			Foi nesse cenário, tentando acertar, que cometi um erro simples, e ao mesmo tempo essencial.<br>
			E foi a partir dele que comecei a entender mais sobre o médico que quero ser, sobre meu jeito de cuidar, sobre o médico que tô tentando me tornar.<br>
			Escolhi começar, não por pressa, mas por confiança.<br>
			Tinha me prepaarado, revisado os nove quadrantes abdominais, pensado nas hipóteses mais comuns, estudado com atenção mesmo sem ter ido à oficina prática, afinal, precisei cuidar da minha própria saúde.<br>
			Achei que daria conta.<br>
			E talvez até tivesse dado, se não fosse um detalhe técnico simples: posicionei a paciente do lado errado no exame hepático.<br>
			Um gesto automático, sem pausa, sem crítica, sem reflexão.<br>
			Resultado? Zereeii.<br>
			Durante a anamnese, não vi uma senhora apenas.<br>
			Vi Maria José, avó, cuidadora, mulher forte que resiste com pouco café e bolacha no café da manhã, frango frito com água com gás no almoço, pão com presunto no jantar.<br>
			Vi alguém que carrega o mundo nas costas, que dorme mal, que acorda no susto, que cuida dos netos e é cuidada por quase ninguém.<br>
			E nesse encontro, o clínico deu lugar ao humano.<br>
			Não pensei nos critérios do LOAS ou no protocolo do CRAS, pensei se ela teria o que comer amanhã.<br>
			E, por um momento, meu foco se deslocou da doença pra fome.<br>
			Naquele momento, eu não pensei nos critérios do LOAS, nem nos fluxos do CRAS.<br>
			Pensei se ela teria o que comer no dia seguinte.<br>
			E percebi algo profundo: estar bem alimentadaa é o começo de qualquer tratamento.<br>
			Antes de pensar em medicamentos ou diagnósticos diferenciais, pensei na comida.<br>
			Porque é dali que vem o mínimo de força pra seguir em frente, e Maria José já vinha há tempos sem esse mínimo.<br>
			É cruel pensar que vivemos em um dos maiores países agroprodutores do mundo e, mesmo assim, a fome nos cerca.<br>
			Produzimos em larga escala, mas falhamos em abastecer com justiça.<br>
			Quando chega alimento, muitas vezes é ultraprocessado, cheio de hormônios, transgênicos, agrotóxicos distante de qualquer noção real de saúde.<br>
			A desigualdade se escancara até no prato.<br>
			E diante disso, não dá pra fingir que o cuidado começa na prescrição: ele começa na mesa.<br>
			Naquele instante, minha maior urgência não era o protocolo da dispepsia.<br>
			Era o vazio no estômago dela não só fisiológico, mas social, afetivo, nutricional.<br>
			Foi essa fome que gritou mais alto.<br>
			E por um instante, meu foco saiu da anatomia e foi direto pra dignidade.<br>
			Errei, infelizmente.<br>
			Talvez eu tenha ido fundo demais nas causas sociais.<br>
			Talveez tenha tentado resolver coisas que nem cabiam a mim.<br>
			Talvez tenha confundido escuta clínica com assistência social.<br>
			Mas não me arrependo.<br>
			Porque ali, diante daquela mulher, eu fui inteiro.<br>
			E ser inteiro é um começo.<br>
			Minha hipótese diagnóstica foi “síndrome gástrica crônica”.<br>
			Tecnicamente, a mais adequada seria “síndrome dispéptica crônica”.<br>
			Fiquei preso demais à anatomia, quando deveria ter olhado mais pra função, pro quadro sindrômico.<br>
			Ainda assim, percorri cada quadrante, tentei encontrar sentido no corpo daquela mulher.<br>
			E, mesmo tropeçando, fui coerente no que propus.<br>
			Escrevi duas folhas tentando dar conta de tudo, talvez tentando, no fundo, resolver mais do que era possível.<br>
			Percebi também que minha escuta extensa, ainda que bem-intencionada, me deixou sem tempo pro exame físico completo.<br>
			Acolhi tanto que me esqueci de acolher o tempo da consulta.<br>
			Preciso encontrar esse equilíbrio: o momento de ouvir, o momento de agir, o momento de sentir e o momento de decidir.<br>
			Em um momento, considerei marcar a posição do fígado com base na percussão, pra identificar alterações no volume hepático algo que eu havia treinado em casa.<br>
			Mas ali, na hora, hesitei.<br>
			Achei que talvez não fosse viável naquele contexto simulado.<br>
			Talvesss fosse.<br>
			Talvez não.<br>
			Mas a dúvida já revelou uma fragilidade.<br>
			O que posso dizer, com honestidade, é que saí dali diferente.<br>
			A medicina que eu quero exercer é a que olha nos olhos, que escuta de verdade, que cuida das pessoas além dos prontuários.<br>
			Quero ser esse médico que se importa.<br>
			Que estuda.<br>
			Que erra e aprende.<br>
			Que sabe acolher a dor do outro sem deixar de acolher a própria vulnerabilidade.<br>
			Outro ponto que me atravessou foi algo mais sutil, mas igualmente importante: eu não sabia se devia perguntar, explicar ou simplesmente agir.<br>
			Durante o exame físico, às vezes me pego esperando uma resposta do além que não vem, como se alguém fosse me dizer, de repente, se eu tava no caminho certo.<br>
			Mas esse alguém não aparece.<br>
			E aí vem a dúvida: sigo em silêncio, intuitivo, ou verbalizo cada passo?<br>
			A verdade é que estamos sendo avaliados e isso muda tudo.<br>
			Fico me perguntando: devo sempre explicar o que estou fazendo?<br>
			Falar em bom tom?<br>
			Justificar cada toque, cada movimento, como forma de mostrar raciocínio clínico e respeitar o paciente ao mesmo tempo?<br>
			Eu acredito que sim.<br>
			Mas, na hora, hesito.<br>
			E essa hesitação me desconecta da segurança que eu queria transmitir.<br>
			Aos poucos, vou entendendo que clareza é cuidado.<br>
			Que comunicar o que farei não é só protocolo, é respeito.<br>
			É vínculo.<br>
			Mesmo na simulação.<br>
			E mais do que isso: é mostrar que sei o que tô fazendo não só pra quem me avalia, mas pra mim também.<br>
			Porque se eu não me escuto, quem vai?<br>
			Meu desejo é ser sanitarista, ou pelo menos estar na gestão, fazer residência em Medicina Preventiva e Social, e atuar com políticas públicas que garantam dignidade, comida, saúde, cuidado.<br>
			Mas diante do erro o que eu poderia ter feito correto?<br>
			Vamos lá, confirmar a posição correta da paciente para o exame hepático, que deve ser feito com ela em decúbito dorsal.<br>
			Esse detalhe simples teria evitado a falha técnica mais grave da avaliação.<br>
			Além disso, teria sido importante explicar antes o que eu faria, antes de tocar, tanto como forma de estabelecer vínculo e respeito, quanto pra ganhar tempo e pontuar melhor na avaliação.<br>
			Outro ponto essencial seria focar nas hipóteses mais prováveis diante do relato clínico, conduzindo um exame físico mais direcionado.<br>
			Isso incluiria a palpação cuidadosa da região epigástrica e do hipocôndrio direito, já que os sintomas eram compatíveis com disfunções gástricas ou biliares.<br>
			Realizar a manobra de Murphy também teria sido relevante, considerando a possibilidade de colelitíase ou colecistite.<br>
			A percussão e a palpação hepática, feitas certinho, permitiriam avaliar melhor o volume e a sensibilidade do fígado, e a palpação profunda poderia ajudar a identificar massas, dor, sinais que orientam a gravidade do quadro.<br>
			Além disso, teria sido fundamental explorar com mais profundidade os hábitos alimentares da paciente e investigar sinais de alarme, como emagrecimento sem explicação, sangue oculto nas fezes, vômitos persistentes ou disfagia.<br>
			E, por fim, algo que preciso reforçar é o hábito de verbalizar mais durante o exame físico.<br>
			Mesmo sendo simulação, é importante dizer o que tô avaliando e por quê isso mostra lógica, segurança e boa comunicação.<br>
			E no fim das contas, isso conta.<br>
			Muitoo.
			<br>
			<br>
			<b>Simulação Vitor</b>
			<br>
			<br>
			Na simulação, Vitor conduziu a anamnese de forma objetiva e organizada, conseguindo levantar dados relevantes como localização da dor, tempo de evolução, fatores de piora e padrão alimentar.<br>
			Entretanto, ficou claro que o atendimento teve um foco muito centrado na queixa física e acabou não contemplando o paciente como um ser integral.<br>
			Embora a dor abdominal e a constipação fossem o ponto de partida, a fala do paciente trazia pistas importantes sobre sua rotina desgastada, alimentação inadequada, baixo consumo de água, sedentarismo e desorganização da vida cotidiana, como o fato de estar com a carteira de vacinação em outra cidade.<br>
			Esses elementos, se escutados com mais cuidado, poderiam revelar sofrimento emocional, sobrecarga, isolamento e negligência com o próprio cuidado.<br>
			Faltou acolhimento.<br>
			Em um cenário real, o toque retal seria um exame extremamente relevante no caso do Vitor.<br>
			Diante de uma constipação importante, com mais de cinco dias sem evacuar, associada a dor no quadrante inferior esquerdo, o toque retal pode ajudar diretamente na identificação da causa do desconforto.<br>
			Esse exame permitiria avaliar a presença de fecaloma no reto, massas endurecidas de fezes impactadas que, quando acumuladas, provocam dor, distensão e até náuseas.<br>
			Além disso, o toque retal fornece informações sobre o tônus do esfíncter anal, permite a investigação de sangramentos ocultos ou visíveis e pode detectar lesões locais, como fissuras ou hemorroidas inflamadas.<br>
			Caso fosse identificado um fecaloma no reto distal, a conduta imediata poderia incluir a retirada manual, conhecida como desimpactação digital.<br>
			Essa técnica consiste em introduzir o dedo enluvado e lubrificado no canal anal e remover, com cuidado, os fragmentos do fecaloma, de forma progressiva.<br>
			Muitas vezes, é necessário fazer esse processo por etapas, respeitando a tolerância do paciente, e monitorando possíveis reflexos vagais, como bradicardia ou queda de pressão.<br>
			Após a remoção inicial, pode-se complementar com um enema de limpeza para facilitar a eliminação das fezes residuais.<br>
			O toque retal, nesse contexto, não só traria clareza diagnóstica, como poderia ser também terapêutico.<br>
			Trata-se de um exame simples, barato e de alto valor clínico, que não deve ser negligenciado na abordagem de pacientes com constipação aguda ou crônica, especialmente quando há sinais de impactação.<br>
			<br>
			<b>Simulação Jadi</b>
			<br>
			<br>
			Se um dia eu estiver mal e precisar ser atendido por alguém, sinceramente, gostaria muito que fosse por uma médica como a Jadi.<br>
			Durante a simulação, ela demonstrou exatamente aquilo que a gente estuda tanto, mas que nem sempre consegue colocar em prática: presença, confiança, escuta verdadeira e precisão no manejo clínico.<br>
			Mesmo sem encaminhar a paciente imediatamente para o hospital o que, tecnicamente, seria a conduta mais prudente diante de um caso sugestivo de hepatite alcoólica com icterícia e hepatomegalia a maneira como a Jadi conduziu a consulta passou tanta segurança que eu, como observador, não fiquei com a sensação de que algo ficou solto.<br>
			Ela foi clara, objetiva, acolhedora.<br>
			Sorriu, olhou nos olhos, teve calma.<br>
			Eu percebi nela o equilíbrio entre o saber técnico e a humanidade no cuidado.<br>
			A paciente não foi tratada apenas como um fígado aumentado ou uma icterícia de 1+/4+.<br>
			Foi tratada como alguém que vive, que trabalha, que sente cansaço, que cuida de plantas, que sai pra tomar uma cerveja e que, nesse momento, precisa de ajuda para se tratar.<br>
			Senti orgulho mesmo.<br>
			Se eu fosse apontar algo a ser aprimorado e digo isso com o máximo respeito seria a dimensão social e ambiental da anamnese.<br>
			A Jadi poderia ter explorado um pouco mais sobre o ambiente em que a paciente vive: se há saneamento básico, como são as condições da moradia, se existe risco ocupacional ou familiar, e se o contexto higiênico-sanitário favorece ou dificulta o controle de uma possível hepatopatia.<br>
			Essas informações não são meros detalhes elas são fundamentais para planejar um cuidado longitudinal realista e efetivo, que vá além da consulta pontual e considere os determinantes sociais que impactam diretamente a saúde e a adesão ao tratamento.<br>
			<br>
			Resposta da questão 1:<br>
			Para compreender as principais doenças relacionadas à síndrome dispéptica, estudei que esse conjunto de sintomas inclui dor ou desconforto epigástrico, queimação, náuseas, sensação de estufamento e saciedade precoce.<br>
			As causas podem ser funcionais (como a dispepsia funcional) ou orgânicas (como gastrite, úlcera péptica e câncer gástrico).<br>
			Trabalhei o diagnóstico diferencial com base em fatores de alarme, história clínica e exames complementares, e revisei o tratamento, que envolve mudanças de estilo de vida, alimentação, controle da ansiedade e uso racional de medicamentos como antiácidos e IBPs.<br>
			MSD MANUAL. Dispepsia. Disponível em: https://www.msdmanuals.com/pt/profissional/distúrbios-gastrointestinais/sintomas-dos-distúrbios-gastrointestinais/dispepsia<br>
			<br>
			Resposta da questão 2:<br>
			Na questão sobre automedicação, aprofundei os riscos do uso indiscriminado de medicamentos sem prescrição, como antiácidos, analgésicos e laxantes.<br>
			Percebi que a automedicação pode mascarar sintomas graves, atrasar diagnósticos importantes e causar complicações como úlceras, insuficiência renal e dependência de certos fármacos.<br>
			Refleti também sobre o papel do médico na educação do paciente quanto ao uso consciente e seguro dos medicamentos.<br>
			PFIZER. Os riscos da automedicação. Disponível em: https://www.pfizer.com.br/noticias/ultimas-noticias/os-riscos-da-automedicacao<br>
			<br>
			Resposta da questão 3:<br>
			Com relação aos riscos do omeprazol, entendi que, apesar de ser amplamente utilizado no manejo da dispepsia e doença do refluxo, seu uso crônico pode provocar deficiências nutricionais (como de vitamina B12, ferro e magnésio), maior risco de infecções intestinais (como Clostridium difficile), além de aumentar o risco de fraturas ósseas em idosos.<br>
			Por isso, seu uso deve sempre ser justificado e por tempo limitado, com reavaliação periódica.<br>
			DRAUZIO VARELLA. Quais os riscos de tomar omeprazol por muito tempo? Disponível em: https://drauziovarella.uol.com.br/medicamentos/quais-os-riscos-de-tomar-omeprazol-por-muito-tempo.<br>
			<br>
			Resposta da questão 4:<br>
			Sobre as doenças relacionadas à síndrome álgica abdominal, constipação e diarreia, revisei causas inflamatórias (como apendicite, colecistite), infecciosas, funcionais (como síndrome do intestino irritável) e obstrutivas.<br>
			Entendi a importância de identificar sinais de gravidade, como febre, sangue nas fezes, vômitos persistentes ou dor localizada.<br>
			Estudei também o tratamento sintomático e específico conforme o diagnóstico, além do papel do exame físico no direcionamento inicial.<br>
			<br>
			Resposta da questão 5:<br>
			Na análise dos sinais de ansiedade, compreendi como manifestações emocionais podem impactar diretamente o sistema gastrointestinal, intensificando sintomas como dor abdominal, diarreia ou constipação.<br>
			Reforcei o conceito de eixo cérebro-intestino e o quanto o acolhimento e o manejo da saúde mental são fundamentais no cuidado integral de pacientes com queixas digestivas.<br>
			AFYA EDUCAÇÃO. Eixo cérebro-intestino: impacto do estresse e ansiedade no intestino. Disponível em: https://portal.afya.com.br/gastroenterologia/eixo-cerebro-intestino-impacto-do-estresse-e-ansiedade-no-intestino.<br>
			<br>
			Resposta da questão 6:<br>
			Para compreender as doenças relacionadas à síndrome ictérica, aprofundei o estudo sobre causas pré-hepáticas (como hemólise), hepáticas (hepatites virais, alcoólicas e medicamentosas) e pós-hepáticas (como obstrução biliar).<br>
			Trabalhei o raciocínio clínico a partir da análise da coloração da pele, olhos e urina, e estudei exames como transaminases, bilirrubinas e ultrassonografia.<br>
			Reforcei o papel da anamnese e dos hábitos de vida na identificação do tipo de icterícia.<br>
			MSD MANUAL. Icterícia. Disponível em: https://www.msdmanuals.com/pt/profissional/distúrbios-hepáticos-e-biliares/abordagem-ao-paciente-com-doença-hepática/icterícia<br>
			REFERÊNCIAS DA ÚLTIMA OFICINA:<br>
			Ministério da Saúde. “Guia alimentar para crianças brasileiras menores de 2 anos”. 2019.<br>
			Sociedade Brasileira de Pediatria. “Manual de Aleitamento Materno”. 2022.<br>
			Ministério da Saúde. Manual Técnico de Processamento do Leite Humano em Bancos de Leite Humano. Brasília: MS, 2008<br>
			Ministério da Saúde. Manual de Normas e Procedimentos para Vacinação. Brasília: MS, 2014 (atualizações anuais via informes técnicos).<br>
			Ministério da Saúde. Caderneta da Criança – Menino/Menina. 2022.<br>
			Ministério da Saúde. Caderno de Atenção Básica nº 33 – Estratégias para o cuidado da criança com diarreia aguda. Brasília: MS, 2010.<br>
			Behrman, R. E., Kliegman, R. M., & Stanton, B. F. Nelson Tratado de Pediatria, 21ª ed. Elsevier, 2020. Capítulos 334 (Distúrbios Intestinais), 136 (Alergia Alimentar).<br>
			Brasil. Estatuto da Criança e do Adolescente – Lei nº 8.069/1990.<br>
			Conselho Nacional de Justiça. “Cartilha da Pensão Alimentícia”. 2021.<br>
			Ministério da Saúde. Protocolos de Vigilância em Saúde – Doenças de Notificação Compulsória. 2021.<br>
			Nelson. Tratado de Pediatria. 21ª ed. Cap. 162 – “Anormalidades genitais do menino”<br>
			Sociedade Brasileira de Pediatria. “Fimose: manejo clínico e indicação de cirurgia”. 2022<br>
			Ministério da Saúde. “Caderno de Atenção Básica – Saúde da Criança: crescimento e desenvolvimento”. 2012<br>
			
			REFLEXÃO DA MINHA PARTICIPAÇÃO NO FECHAMENTO<br>
			Algo que tenho percebido em mim, e que preciso reconhecer com franqueza, é a dificuldade de participar ativamente quando estou em ambientes em que outras pessoas falam demais ou tomam conta da conversa.<br>
			Isso me atinge especialmente nas tutorias. Mesmo quando estudo e tenho algo a contribuir, fico calado. Não por falta de interesse, mas porque sinto que o espaço não favorece a escuta de todos e isso me silencia.<br>
			Essa semana, além disso, fui bastante afetado pelo resultado do conselho de NCS.<br>
			Estar em risco, mesmo estudando, foi difícil. Mais ainda quando vejo colegas que colam abertamente sendo aprovados e seguindo como se nada estivesse acontecendo.<br>
			Isso mexeu profundamente com meu psicológico e com a minha autoestima como estudante, entre a São Judas e Enfermagem na USP eu preferi a São Judas sabe, eu tive muitos problemas pessoais na primeira parte do 2º semestre e isso afetou muito meu psicológico.<br>
			Eu consegui evoluir, eu só estudo por livro porque não quero ser médico de YouTube.<br>
			Não é só tristeza, é uma sensação de injustiça que me atravessa. Dói perceber que o esforço parece importar menos do que a esperteza de burlar o sistema.<br>
			Fico pensando o quanto é difícil se desenvolver plenamente num ambiente que não parece seguro.<br>
			Onde a cobrança é alta para quem tenta, mas a consequência não vem para quem desrespeita.<br>
			Onde se espera desempenho, mas não se oferece acolhimento verdadeiro.<br>
			E isso, inevitavelmente, refletiu no meu rendimento em Habilidades Médicas.<br>
			Mesmo assim, HM é uma das poucas disciplinas em que me sinto minimamente à vontade.<br>
			É onde acredito que meu esforço, minha intenção e meu cuidado são enxergados mesmo quando o resultado técnico não é o melhor.<br>
			Tenho confiança de que, aqui, não serei resumido a uma nota.<br>
			Que meu potencial será considerado com humanidade.<br>
			E isso me dá forças para continuar tentando, mesmo quando tudo parece pesado.<br>
			<br>
			ESTAÇÕES<br>
			ESTAÇÃO 1<br>
			<br>
			ATIVIDADE A:<br>
			Questão 1 - Feedback<br>
			Esta atividade prática foi essencial para consolidar os conhecimentos teóricos sobre o exame físico abdominal.<br>
			A divisão de tarefas no grupo permitiu que todos os participantes observassem e participassem ativamente do processo.<br>
			O uso do simulador foi uma ferramenta valiosa para treinar as técnicas com segurança, antes do contato com pacientes reais.<br>
			Observar detalhes como a postura do examinador, a comunicação com a paciente e a forma de tocar o abdome reforçou a importância de uma abordagem humanizada e técnica.<br>
			Além disso, o feedback recebido foi importante para identificar pontos a melhorar.<br>
			Pretendo seguir praticando essas técnicas e revisar os conteúdos indicados para me sentir mais seguro em futuras consultas.<br>
			<br>
			Questão 4 – Comunicação dos Achados e Registro no Prontuário da Paciente (Simulador)<br>
			Explicação para a paciente (simulada):<br>
			Após a realização do exame físico abdominal, informamos à paciente simulada que o exame se encontrava dentro da normalidade.<br>
			Explicamos que não foram observados sinais de dor, alterações anatômicas ou massas palpáveis.<br>
			Ressaltamos que os ruídos intestinais estavam normais, o que indica um bom funcionamento do sistema digestivo.<br>
			<br>
			Registro dos achados no prontuário (modelo):<br>
			Exame físico abdominal:<br>
			Abdome plano, com presença de ruídos hidroaéreos normoativos à ausculta.<br>
			Flácido e indolor à palpação superficial e profunda.<br>
			Não se observaram massas abdominais, visceromegalias ou sinais de irritação peritoneal.<br>
			Hepatimetria de 8 cm na linha hemiclavicular direita e de 4 cm na linha esternal.<br>
			Borda hepática lisa, regular, palpável a 1 cm abaixo do rebordo costal direito.<br>
			Percussão sem alterações.<br>
			Exame dentro dos padrões de normalidade.<br>
			<br>
			Questão 5 – Reflexão e Correlação com as Atividades B e C<br>
			A execução prática do exame físico abdominal (Atividade A) foi fundamental para integrar o conteúdo das atividades teóricas B e C.<br>
			Na Atividade B, o uso da inteligência artificial facilitou o entendimento dos fundamentos do exame de forma didática, contribuindo para memorizar os passos e compreender a importância de cada etapa.<br>
			Esse suporte foi essencial na preparação para a simulação prática.<br>
			Na Atividade C, a leitura do capítulo 14 do livro Semiologia Clínica e a vídeo-aula serviram como recursos visuais e conceituais importantes para a correta execução das técnicas.<br>
			Isso aumentou significativamente minha segurança no momento de realizar o exame.<br>
			Durante a prática, pude aplicar o conhecimento teórico com foco no cuidado ao paciente, priorizando o conforto, o respeito e a comunicação clara.<br>
			Trabalhar em grupo foi extremamente enriquecedor, pois pude aprender com os colegas, receber e oferecer feedbacks construtivos, além de observar diferentes estilos de abordagem clínica.<br>
			A experiência com o simulador me ajudou a corrigir aspectos técnicos importantes, como o posicionamento das mãos e o início da palpação.<br>
			Em resumo, a combinação entre teoria, tecnologia (IA) e prática tornou a aprendizagem mais completa e eficiente.<br>
			Esse modelo de ensino fortalece o raciocínio clínico e o preparo técnico, e pretendo continuar revisando os materiais e praticando para aperfeiçoar minha atuação como futura profissional de saúde.<br>
			<br>
			ATIVIDADE B<br>
			<br>
			A) A IA trouxe dados fidedignos?<br>
			Sim. A resposta da IA foi baseada em conhecimentos médicos amplamente reconhecidos e utilizados no ensino médico tradicional.<br>
			Os exames físicos abdominais listados — como inspeção, ausculta, percussão e palpação — são componentes clássicos do exame físico abdominal.<br>
			As descrições foram coerentes com a literatura médica padrão.<br>
			<br>
			B) Os dados estavam completos ou a ferramenta trouxe algum dado novo?<br>
			A resposta foi bastante completa em relação aos exames físicos fundamentais do abdome.<br>
			Além disso, a IA pode incluir alguns testes especiais (como sinal de Blumberg, sinal de Murphy, entre outros), o que enriquece o conteúdo e pode ser considerado um acréscimo útil à formação do aluno.<br>
			Isso pode representar um dado novo ou aprofundado, dependendo do nível de conhecimento prévio do estudante.<br>
			<br>
			C) Qual a fonte dos dados utilizados pela ferramenta?<br>
			A IA foi treinada em uma ampla variedade de textos, incluindo livros, artigos científicos, diretrizes clínicas e recursos educacionais de domínio público.<br>
			No entanto, a IA não fornece automaticamente as fontes específicas das informações, a menos que seja solicitada.<br>
			Para garantir maior confiança, é possível pedir que a IA cite referências ou comparar com livros como o “Bates – Guia de Exame Físico” ou “Semiologia Médica”, de diversos autores.<br>
			<br>
			D) A IA foi útil para ajudar a aprender o exame físico do abdome?<br>
			Sim. A IA foi útil ao fornecer uma explicação clara, objetiva e acessível, servindo como uma ferramenta complementar ao estudo tradicional.<br>
			Ela permite revisão rápida, reforço de conteúdo e esclarecimento de dúvidas pontuais, além de poder simular casos clínicos ou perguntas de revisão para autoavaliação.<br>
			<br>
			E) Reflexão para o portfólio:<br>
			O uso da inteligência artificial, como o ChatGPT, se mostrou uma ferramenta promissora no processo de aprendizagem em Medicina.<br>
			Ao estudar o exame físico do abdome, percebi que a IA consegue sintetizar informações essenciais de maneira clara e direta, o que facilita a compreensão dos conceitos e sua memorização.<br>
			Embora não substitua as aulas práticas nem a leitura de livros especializados, ela se apresenta como um excelente recurso de apoio, especialmente na revisão de conteúdos e no esclarecimento de dúvidas.<br>
			A IA também permite personalizar o estudo conforme minhas necessidades.<br>
			No entanto, é importante manter um olhar crítico sobre as informações fornecidas, sempre verificando com fontes confiáveis e professores quando necessário.<br>
			<br>
			ATIVIDADE C<br>
			A. Atendimento e Análise Clínica<br>
			1. Anamnese – Pontos mais importantes observados:<br>
			Dor abdominal iniciada há cerca de 24 horas, localizada inicialmente na região periumbilical e atualmente fixa, de caráter constante e agravada com movimentos.<br>
			Náuseas persistentes e vômito com conteúdo alimentar.<br>
			Episódios de febre leve e alterações no hábito intestinal (evacuação ausente ontem, fezes amolecidas hoje).<br>
			Inapetência desde o início do quadro, indicando envolvimento sistêmico.<br>
			História médica significativa: hipotireoidismo tratado, múltiplas cirurgias prévias (incluindo duas cesáreas, cirurgia na tireoide e na cabeça).<br>
			Sem uso de drogas, álcool ou tabaco. Sem alergias conhecidas.<br>
			História familiar positiva para câncer de intestino e mama.<br>
			Esses dados reforçam um quadro clínico compatível com abdome agudo inflamatório, sendo apendicite aguda com plastrão a principal hipótese.<br>
			<br>
			2. Exame físico – Pontos mais importantes observados:<br>
			Febre (37,9 ºC) e frequência cardíaca elevada (96 bpm), sugestivos de resposta inflamatória sistêmica.<br>
			Ruídos hidroaéreos ausentes (indicando íleo paralítico).<br>
			Timpanismo abdominal difuso, sugestivo de distensão gasosa.<br>
			Sinal de Dunphy positivo (dor ao tossir), indicativo de irritação peritoneal.<br>
			Plastrão palpável em fossa ilíaca direita, associado a dor intensa.<br>
			Sinais de Blumberg e Rovsing positivos, ambos altamente sugestivos de apendicite com irritação peritoneal localizada.<br>
			Toque retal normal, sem sangramento ou massas pélvicas.<br>
			<br>
			B. Exames Complementares Solicitados e Resultados<br>
			Exames solicitados:<br>
			Hemograma completo – mostrou provável leucocitose (esperado em apendicite).<br>
			Proteína C reativa (PCR) – aumentada, indicativa de inflamação.<br>
			Urina tipo 1 (EAS) – sem alterações (descarta ITU).<br>
			Beta-HCG – negativo, descartando gravidez ectópica.<br>
			Amilase e lipase – dentro dos valores normais (descarta pancreatite).<br>
			Tomografia computadorizada de abdome total – evidenciou apêndice aumentado de calibre, espessado, com densificação da gordura adjacente e formação de plastrão em fossa ilíaca direita. Sem sinais de perfuração.<br>
			<br>
			Conclusão:<br>
			Os exames confirmam o diagnóstico de apendicite aguda com plastrão inflamatório.<br>
			<br>
			C. Revisão e Avaliação do Conhecimento<br>
			Esta atividade reforçou diversos aprendizados fundamentais:<br>
			A importância de uma anamnese direcionada, valorizando características da dor (início, localização, irradiação, fatores de piora).<br>
			Como os sinais físicos clássicos (Blumberg, Rovsing, Dunphy) ajudam a diferenciar causas de abdome agudo.<br>
			A relevância da correlação clínica com exames complementares, especialmente a tomografia, na definição do diagnóstico e da conduta cirúrgica.<br>
			O valor da organização do raciocínio clínico e da atuação em equipe multidisciplinar (enfermagem, cirurgia, anestesia).<br>
			<br>
			D. Reflexão para o Portfólio<br>
			Participar da atividade da Estação 1 foi uma excelente oportunidade para aplicar os conhecimentos adquiridos nas aulas teóricas em um contexto prático e simulado.<br>
			Ao conduzir a anamnese de forma estruturada, percebi como detalhes sutis como o padrão da dor, a evolução temporal e os sintomas associados são cruciais para formular hipóteses diagnósticas.<br>
			Além disso, o exame físico exigiu atenção cuidadosa à técnica e à observação da reação do paciente, o que me fez valorizar ainda mais o treinamento prático.<br>
			A comparação dos achados clínicos com os exames complementares ajudou a consolidar o diagnóstico de apendicite com plastrão, mostrando a importância da tomografia em casos mais complexos.<br>
			Também aprendi como estruturar um plano de cuidado eficaz e individualizado, incluindo jejum, antibioticoterapia, analgesia e a indicação cirúrgica.<br>
			Em conjunto com as outras atividades do módulo, esta estação me fez compreender melhor o raciocínio diagnóstico em dor abdominal aguda e me incentivou a estudar com mais profundidade os quadros de abdome agudo.<br>
			Foi uma experiência que contribuiu diretamente para minha formação clínica.<br>
			<br>
			<img src="/hm_semestre3_img1.png" style="max-width: 100%; display: block; margin: 1rem auto; border-radius: 0.5rem;" alt="Imagem Estação 3">

			ESTAÇÃO 3<br>
			<br>
			ATIVIDADE A: não foi possível realizar<br>
			<br>
			ATIVIDADE B- Sinto minha barriga grande<br><br>
			A. Em relação ao quadro inicial de Jesuína, mencione os pontos mais importantes que você observou.<br>
			A paciente Jesuína Oliveira, 68 anos, aposentada, procurou atendimento com queixa de dor abdominal há dois dias.<br>
			Ela descreveu a dor como intensa, generalizada em toda a região abdominal, com pontuação 8/10 na escala de dor.<br>
			A dor vinha em crises fortes, que davam vontade de chorar, mas com alívio passageiro.<br>
			Além disso, apresentou episódios de vômito (quatro vezes no dia), com conteúdo de coloração verde-amarelada, náuseas persistentes e ausência total de evacuação e eliminação de gases desde o dia anterior, sugerindo um quadro obstrutivo.<br>
			Ela não apresentou febre, mas relatou uso de dipirona e plasil.<br>
			Já possui antecedentes de hipertensão arterial sistêmica, em uso regular de losartana.<br>
			Informou cirurgias prévias de apendicectomia, colecistectomia e cesárea.<br>
			Negou tabagismo e etilismo.<br>
			Esses sinais e sintomas iniciais apontam para uma possível obstrução intestinal, considerando os episódios de vômitos biliosos, distensão abdominal, ausência de evacuação e flatos, além da dor abdominal em cólica.<br>
			<br><br>
			B. Durante a internação, quais os pontos mais importantes que você observou?<br>
			Durante a avaliação clínica, alguns achados foram marcantes:<br>
			Sinais vitais mostraram frequência cardíaca elevada (105 bpm), o que pode sugerir desidratação ou resposta inflamatória.<br>
			O exame abdominal revelou ruídos hidroaéreos metálicos e hipoativos, timpanismo à percussão e dor difusa à palpação.<br>
			O abdome estava visivelmente distendido.<br>
			A descompressão brusca foi negativa, descartando sinais evidentes de irritação peritoneal.<br>
			O toque retal não identificou sangue ou massas, e os demais sistemas (cardíaco, respiratório, neurológico) estavam sem alterações significativas.<br>
			A suspeita clínica foi de abdome agudo obstrutivo, um quadro que requer intervenção cirúrgica emergencial.<br>
			Foram solicitados exames complementares para confirmar o diagnóstico e avaliar possíveis complicações, incluindo hemograma, eletrólitos, gasometria com lactato, e exames de imagem como radiografia e tomografia de abdome e pelve.<br>
			<br><br>
			C. Realize a revisão e a avaliação do conhecimento.<br>
			Essa atividade reforçou aspectos essenciais no atendimento a pacientes com dor abdominal aguda.<br>
			A diferenciação entre os diversos tipos de abdome agudo — inflamatório, obstrutivo, perfurativo ou vascular — é fundamental para uma abordagem rápida e segura.<br>
			A obstrução intestinal, como apresentada neste caso, se caracteriza por dor em cólica, distensão abdominal, vômitos (muitas vezes biliosos) e ausência de evacuação e eliminação de gases.<br>
			A ausculta com ruídos metálicos e a percussão timpânica são sinais típicos.<br>
			Esses achados, combinados com a história clínica e exames de imagem, guiam a decisão pela cirurgia.<br>
			Além disso, revisamos a importância da reposição volêmica precoce, controle da dor, antibioticoterapia e sondagem nasogástrica como medidas iniciais antes da cirurgia.<br>
			O conhecimento teórico foi colocado em prática, possibilitando uma atuação clínica mais segura e fundamentada.<br>
			<br><br>
			D. Por fim, escreva no seu portfólio suas reflexões sobre a atividade.<br>
			Participar dessa simulação foi extremamente enriquecedor para o meu aprendizado.<br>
			O caso da paciente Jesuína me permitiu aplicar, de forma prática, os conhecimentos adquiridos sobre abdome agudo, especialmente em relação à suspeita de obstrução intestinal.<br>
			A partir da anamnese e do exame físico, consegui perceber a importância de ouvir atentamente o paciente e correlacionar cada sintoma com os achados clínicos.<br>
			Aprendi que o raciocínio clínico é um processo dinâmico, que exige prática, atenção aos detalhes e conhecimento técnico.<br>
			Refletir sobre a conduta e reconhecer a urgência cirúrgica nesse tipo de situação reforçou minha responsabilidade futura como médica.<br>
			A integração entre teoria e prática, especialmente com discussões em grupo e supervisão docente, tornou essa experiência ainda mais significativa.<br>
			Saio dessa atividade mais confiante na abordagem de pacientes com dor abdominal, e motivada a continuar estudando para fortalecer meu julgamento clínico.<br>
			<br><br>
			ATIVIDADE C<br>
			A. Anamnese – Pontos mais importantes observados do atendimento inicial até a alta<br>
			Dor intensa em região epigástrica, contínua, sem irradiação.<br>
			Início após o almoço, sem alívio com uso de Buscopan.<br>
			Piora da dor após tentativas de alimentação.<br>
			Náuseas e vômitos (eliminação de todo conteúdo alimentar).<br>
			Perda de apetite e relato de perda de 12 kg nos últimos 6 meses.<br>
			Urina escurecida, mas sem dor para urinar.<br>
			Sem diarreia ou sintomas respiratórios.<br>
			Sem sintomas urinários relevantes.<br>
			Histórico de cirurgia prévia no joelho; sem alergias ou comorbidades conhecidas.<br>
			Estilo de vida ativo, sem tabagismo ou uso de drogas ilícitas.<br>
			<br><br>
			B. Exame físico – Pontos mais importantes observados<br>
			Sinais vitais:<br>
			SpO₂: 97%<br>
			FC: 98 bpm (taquicardia leve)<br>
			FR: 22 irpm (discretamente elevada)<br>
			Cardiopulmonar: Sem alterações significativas.<br>
			Abdome:<br>
			Flácido, doloroso difusamente, mais intenso no andar superior.<br>
			Sem sinais de peritonite localizada.<br>
			Ruídos hidroaéreos presentes, mas diminuídos.<br>
			Timpanismo difuso à percussão.<br>
			<br><br>
			C. Diagnóstico e conduta – Pontos mais importantes observados<br>
			Diagnóstico clínico presumido: Pancreatite aguda, provavelmente de causa biliar.<br>
			Conduta inicial:<br>
			Jejum absoluto (repouso pancreático).<br>
			Hidratação venosa vigorosa.<br>
			Analgesia intensiva.<br>
			Estratificação da gravidade recomendada via Escore de Marshall ou SOFA.<br>
			Exames solicitados:<br>
			Radiografia de abdome agudo.<br>
			Urina tipo I.<br>
			Amilase, hemograma, PCR.<br>
			Ultrassonografia de abdome total.<br>
			<br><br>
			D. Comparação das hipóteses diagnósticas e exames entre colegas e plataforma<br>
			Hipóteses discutidas pelo grupo:<br>
			Gastrite aguda.<br>
			Úlcera péptica perfurada.<br>
			Colecistite.<br>
			Obstrução intestinal.<br>
			Hipótese final definida com base clínica e na plataforma:<br>
			Pancreatite aguda (compatível com dor epigástrica contínua + sintomas gastrointestinais intensos + perda ponderal).<br>
			Convergência com a plataforma:<br>
			Exames indicados foram condizentes com diretrizes clínicas.<br>
			A avaliação das enzimas pancreáticas e imagem abdominal foi fundamental.<br>
			A plataforma ajudou a orientar e confirmar o raciocínio clínico, validando o diagnóstico e conduta.<br>
			<br><br>
			E. Realize a revisão e avaliação do conhecimento<br>
			A atividade permitiu consolidar conhecimentos fundamentais sobre quadros de dor abdominal aguda, especialmente no contexto de pancreatite aguda.<br>
			Durante o atendimento ao paciente Roberto, foi essencial aplicar o raciocínio clínico com base em uma anamnese detalhada, exame físico bem conduzido e interpretação criteriosa dos sinais e sintomas.<br>
			A dor epigástrica contínua, a ausência de resposta ao Buscopan, a piora após alimentação e os vômitos intensos indicaram a necessidade de investigação de patologias mais graves, o que reforça a importância de não subestimar dores abdominais que não têm características típicas de cólica.<br>
			Além disso, a perda ponderal significativa, mesmo sem comorbidades declaradas, foi um sinal de alerta.<br>
			Com o suporte da plataforma e o debate entre os colegas, foi possível comparar hipóteses diagnósticas, identificar a pancreatite como o diagnóstico mais compatível, e reconhecer a importância de exames laboratoriais e de imagem específicos para confirmação e estratificação da gravidade.<br>
			<br><br>
			F. Por fim, escreva no seu portfólio suas reflexões sobre a atividade<br>
			Esta atividade foi essencial para reforçar minha compreensão sobre o diagnóstico e manejo de quadros abdominais agudos, como a pancreatite.<br>
			A simulação permitiu vivenciar uma situação clínica realista, exigindo a aplicação de habilidades de escuta ativa, formulação de hipóteses e tomada de decisão.<br>
			Percebi a importância de uma anamnese bem estruturada, que, quando aliada a um exame físico completo, fornece a base necessária para um raciocínio clínico eficaz.<br>
			A troca de ideias com o grupo e o confronto com as orientações da plataforma enriqueceram ainda mais o aprendizado, mostrando que nem sempre os sinais são claros desde o início, e que é preciso considerar o quadro como um todo.<br>
			Saio desta atividade mais confiante em minha capacidade de diferenciar diagnósticos semelhantes e de tomar decisões clínicas embasadas.<br>
			Reforcei também o valor do trabalho em equipe e da consulta a diretrizes atualizadas como ferramentas fundamentais para a prática médica segura e eficaz.<br>
			<br><br>
			ATIVIDADE D<br>
			1. Mapa Mental: Caso da paciente Jesuína<br>
			Solicitação para a IA:<br>
			"Elabore um mapa mental para estudantes do 2º ano de Medicina, apresentando a ideia central e seus respectivos ramos e sub-ramos, acerca da evolução do quadro clínico da paciente Jesuína, a qual apresenta as seguintes características:<br>
			Dor abdominal intensa, em cólica, com início há 2 dias<br>
			Vômitos biliosos (4 episódios)<br>
			Distensão abdominal<br>
			Ausência de evacuação e eliminação de gases<br>
			Abdome timpânico à percussão<br>
			Ruídos hidroaéreos metálicos e hipoativos<br>
			Cirurgias prévias: apendicectomia, colecistectomia e cesárea<br>
			Hipertensa, em uso de losartana<br>
			Diagnóstico clínico: Abdome agudo obstrutivo<br>
			Exames: Hemograma, eletrólitos, gasometria com lactato, RX e TC de abdome<br>
			Conduta: Hidratação, analgesia, antibióticos, sondagem nasogástrica, laparotomia exploradora<br>
			Evolução: Internação com melhora progressiva após intervenção cirúrgica."<br>
			<br><br>
			2. Dados em lista: Caso Jesuína<br>
			Anamnese inicial:<br>
			Dor abdominal em cólica há 2 dias<br>
			Vômitos biliosos<br>
			Distensão abdominal<br>
			Ausência de evacuação e eliminação de gases<br>
			Sem febre<br>
			Cirurgias prévias (apêndice, vesícula, cesárea)<br>
			Hipertensa (uso de losartana)<br>
			Sem alergias<br>
			Sem tabagismo ou etilismo<br>
			Evolução clínica até alta:<br>
			Sinais vitais estáveis com taquicardia leve<br>
			Abdome distendido, timpânico e doloroso<br>
			Ruídos hidroaéreos metálicos<br>
			Diagnóstico de abdome agudo obstrutivo<br>
			Exames compatíveis com obstrução intestinal<br>
			Tratamento cirúrgico bem-sucedido<br>
			Melhora clínica progressiva durante a internação<br>
			<br><br>
			3. Mapa Mental: Caso do paciente Roberto<br>
			Solicitação para a IA:<br>
			"Elabore um mapa mental para estudantes do 2º ano de Medicina, apresentando a ideia central e seus respectivos ramos e sub-ramos, acerca da evolução do quadro clínico do paciente Roberto, o qual apresenta as seguintes características:<br>
			Dor epigástrica contínua e intensa iniciada após refeição<br>
			Náuseas e vômitos alimentares (2 episódios)<br>
			Sem diarreia, febre ou dor urinária<br>
			Urina escurecida<br>
			Perda de 12 kg nos últimos 6 meses<br>
			Ausculta com ruídos levemente diminuídos<br>
			Abdome flácido e doloroso no andar superior<br>
			Diagnóstico: Pancreatite aguda (possivelmente biliar)<br>
			Conduta: Jejum, hidratação venosa, analgesia vigorosa<br>
			Exames: Amilase, lipase, PCR, hemograma, ultrassonografia<br>
			Estabilização do quadro e encaminhamento para seguimento ambulatorial após melhora clínica."<br>
			<br><br>
			4. Dados em lista: Caso Roberto<br>
			Anamnese inicial:<br>
			Dor intensa na região epigástrica, contínua<br>
			Início após refeição<br>
			Náuseas e vômitos (2 vezes)<br>
			Urina escurecida<br>
			Perda de peso significativa<br>
			Sem diarreia, febre ou sintomas urinários importantes<br>
			Sem doenças crônicas ou uso regular de medicamentos<br>
			Histórico cirúrgico prévio (joelho)<br>
			Evolução clínica até alta:<br>
			Sinais vitais com leve taquicardia<br>
			Abdome doloroso, especialmente no andar superior<br>
			Ruídos hidroaéreos diminuídos<br>
			Diagnóstico de pancreatite aguda<br>
			Tratamento clínico: jejum, hidratação, analgesia<br>
			Exames compatíveis com pancreatite (amilase, lipase, PCR)<br>
			Melhora clínica e alta com orientações para seguimento<br>
			<br><br>
			5. Análise com o grupo – Discussão sobre o uso da IA<br>
			• A IA trouxe dados compatíveis ou criou fatos inexistentes?<br>
			Os dados gerados pela IA foram totalmente compatíveis com os quadros clínicos apresentados. Nenhuma informação foi inventada. O modelo apenas organizou e aprofundou os dados já fornecidos, mantendo coerência com o caso e com o raciocínio clínico esperado de um estudante de Medicina.<br>
			• Os dados estavam completos?<br>
			Sim. A IA conseguiu compilar todos os pontos relevantes das anotações clínicas, transformando-os em mapas mentais bem estruturados. Além disso, os ramos e sub-ramos facilitaram a compreensão do quadro clínico e permitiram visualizar melhor a linha do tempo desde a admissão até a alta.<br>
			• A IA foi útil para ajudar a montar o mapa mental?<br>
			Sim, foi muito útil. A ferramenta não só auxiliou na organização do raciocínio como também tornou o estudo mais interessante. Ao estruturar as informações de forma visual e hierarquizada, o mapa mental facilita a memorização e a revisão dos casos clínicos. Foi especialmente eficaz para estudantes do ciclo clínico, que precisam conectar anamnese, exame físico, diagnóstico e conduta.<br>
		</details>
	</div>
</main>

<style>
	details {
		text-align: center;
		justify-content: center;
		margin: 0 auto;
		border: 1px solid;
		width: 50vh;
		border-radius: 0.5em;
	}
	
	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	.Banner {
		height: 20vh;
		width: 80vh;
		border-radius: 0.5rem;
		display: block;
		margin: 0 auto;
	}

	details {
		text-align: left; /* melhor leitura */
		justify-content: center;
		margin: 0 auto;
		border: 1px solid;
		width: 90%; /* mais natural que 50vh */
		max-width: 600px;
		border-radius: 0.5em;
		padding: 1em;
		box-sizing: border-box;
		overflow-wrap: break-word;
		word-break: normal;
	}
	details p {
		white-space: pre-line;
		overflow-wrap: break-word;
		word-break: normal;
		margin-bottom: 1em;
	}

</style>